import type {
  DrawdownCalculationResult,
  ManualOverride,
} from '@/services/drawdowns/drawdownCalculationService';

export type CallType = 'percentage' | 'fixed_amount';
export type WizardStep = 'parameters' | 'allocations' | 'review';

export const WIZARD_STEPS: WizardStep[] = ['parameters', 'allocations', 'review'];

export const STEP_LABELS: Record<WizardStep, string> = {
  parameters: 'Parameters',
  allocations: 'Allocations',
  review: 'Review',
};

export interface DrawdownParameters {
  fundId: string;
  callType: CallType;
  inputValue: number;
  currency: string;
  issueDate: string;
  dueDate: string;
  purpose: string;
  description: string;
}

export interface WizardState {
  currentCalculation: DrawdownCalculationResult | null;
  calculationHash: string | null;
  parameters: DrawdownParameters;
  manualOverrides: Map<string, ManualOverride>;
  currentStep: WizardStep;
  hasAttemptedNext: boolean;
  fieldErrors: Record<string, string>;
  errors: string[];
  warnings: string[];
}